import SeoServicePage from "@/pages/services/SeoServicePage";

const TeethWhiteningPage = () => (
  <SeoServicePage
    slugOverride="teeth-whitening-cost-kalyan"
    canonicalOverride="/teeth-whitening-kalyan"
    breadcrumbsOverride={[
      { label: "Advanced Treatments", path: "/services" },
      { label: "Teeth Whitening Kalyan" },
    ]}
  />
);

export default TeethWhiteningPage;